import gql from "graphql-tag";
import { possibleEJIServiceFields } from "./calculatePossibleEjiPriceInfo";

export const GET_ALL_POSSIBLE_SERVICES = gql`query getAllPossibleServices($getAllPossibleServicesInput: GetAllPossibleServicesInput!) {
  getAllPossibleServices(getAllPossibleServicesInput: $getAllPossibleServicesInput) {
      ${possibleEJIServiceFields}
  }
}`;
